/**
 * Copy for the public ethics complaint form.
 *
 * A collection type (`complaint-form`), matching how every other content type
 * in the CADRE Strapi project is modelled — only the first entry is used. Every
 * field is optional on the client: if the content type does not exist yet, or a
 * field is left blank, the component falls back to its built-in default and the
 * form still renders.
 */
export const COMPLAINT_FORM_QUERY = `ComplaintForm {
    complaintForms(sort: "id:ASC") {
      data {
        id
        attributes {
          program_title
          form_title
          formFields
          handbook_note
          legal_notice
          contact_section_title
          contact_section_description
          complaint_section_title
          complaint_section_description
          supporting_documents_note
          submitted_title
          submitted_message
          submitted_follow_up
        }
      }
    }
  }`;
